import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Button } from '@material-ui/core'
import "../styles/AdminSeniorApplication.css"
import Pagination from '@material-ui/lab/Pagination';
import { upperFirst } from 'lodash'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { ApiURL } from '../constants/ApiUrl'
// import AdminApplicationsView from './AdminApplicationsView'

import axiosInstance from "../services/AxiosInstance"
// import React, {useState, useEffect} from 'react'
// import { useDispatch } from 'react-redux'
// import {Link} from "react-router-dom"
import "../styles/ApplicationHome.css"

function AdminApplications() {
    const [Type, setType] = useState('')

    const [AppList, setAppList] = useState([])
    var userList = []
    const [Page, setPage] = useState(0)
    const [TotalPages, setTotalPages] = useState(0)
    const [TotalItems, setTotalItems] = useState(0)
    const dispatch = useDispatch();
    const history = useHistory();

    async function getData(page, limit) {
        // const result = await axios.post(`${ApiURL}/api/get_old_updateApplication?page=${page}&limit=${limit}`);
        const result = await axiosInstance.post(`${ApiURL}/api/get_old_updateApplication?page=${page}&limit=${limit}`);
        console.log(result.data.data,"myres")
        result.data.data.forEach(element => {
            if (element.isVerified === false && element.appType==="old") {
                userList.push(element)

            }

            setAppList(userList)


        });

        ;
        
        setTotalPages(result.data.totalPages);
        setTotalItems(result.data.totalItems);
    }
    useEffect(() => {
        getData(0, 50);
    }, [])

    useEffect(() => {
        getData(Page, 50);
    }, [Page, Type])

    const handlePageChange = (e, value) => {

        setPage(value - 1);
    }
    const handleView = async (value) => {
        // const result = await axios.get(`${ApiURL}/api/get_applications/${value}`);
        const result = await axiosInstance.get(`${ApiURL}/api/get_applications/${value}`);
        dispatch({ type: "SELECTED_APPLICATION", payload: result.data.data });

        history.push(`/admin/OldMem/${value}`)
    }

    return (
        <>
            <div className="admNewApp">
                <h1>Update Request</h1>
                <Pagination count={TotalPages} page={Page + 1} onChange={handlePageChange} variant="outlined" shape="rounded" />
                <p><b>{TotalItems} pending applications.</b></p>
                <table className="appTable">
                    <tr>
                        <th>S.No</th>
                        <th>Member No</th>
                        <th>Doctor Name</th>
                        <th>Submission Date</th>
                        <th>Application Status</th>
                        <th>Action</th>
                    </tr>
                    {
                        AppList.map((item, index) => (
                            <tr key={item._id}>
                                <td>{(Page * 50) + (index + 1)}</td>
                                <td>{item.mem_no}</td>
                                <td>{item.name}</td>
                                <td>{new Date(item.updatedAt).toDateString()}</td>
                                <td>{item.isVerified ? "Verified" : "Unverified"}</td>
                                <td><Button variant="contained" color="primary" onClick={() => handleView(item._id)}>View</Button></td>
                            </tr>

                        ))
                    }
                </table>
                {/* <AdminApplicationsView/> */}
            </div>
        </>
    )
}


export default AdminApplications
